import {IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar} from '@ionic/react';
import './Home.css';
import AnswerColumn from "../components/AnswerColumn";

function Home() {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton></IonMenuButton>
          </IonButtons>
          <IonTitle>問題をとくやつ</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {/*<IonHeader collapse="condense">*/}
        {/*  <IonToolbar>*/}
        {/*    <IonTitle size="large">Blank</IonTitle>*/}
        {/*  </IonToolbar>*/}
        {/*</IonHeader>*/}
        <AnswerColumn/>
      </IonContent>
    </IonPage>
  )
}

export default Home;